// @flow

// Exports
export default function asObject (value: mixed): Object {
  if (value == null || typeof value !== 'object') {
    return {}
  } else if (Array.isArray(value)) {
    return value.reduce(function (acc: Object, v: mixed, i: number): Object {
      acc[i] = v
      return acc
    }, {})
  }

  return value
}
